import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => {
  return {
    stickyHeaderContainer: {
      backgroundColor: theme.new.color.background.page,
      borderBottom: `1px solid ${theme.new.color.line.hairline}`,
      display: 'flex',
      height: '56px',
      flexFlow: 'column',
      justifyContent: 'center',
      marginLeft: '-32px',
      padding: '16px 32px',
      position: 'fixed',
      width: '100%',
      zIndex: 5,
    },
  };
});
